// src/components/BodyAttributes.tsx
"use client";

import { useEffect } from "react";

export default function BodyAttributes() {
  useEffect(() => {
    const body = document.body;

    // ✅ Ensure these attributes exist before hydration
    body.setAttribute("data-page", "home");
    body.setAttribute("data-spy", "scroll");
    body.setAttribute("data-target", "#one-page-nav");
    body.setAttribute("data-offset", "120");

    //console.log("✅ Body attributes updated");
  }, []);

  return null;
}
